import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { FONDOFIJO_REPORTES } from 'constants/codigosTransacciones'

import ReportePage from './reporte'

export default function FondosFijosPage() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${FONDOFIJO_REPORTES}`} component={ReportePage} />
      </Switch>
    </Suspense>
  )
}
